import { render, staticRenderFns } from "./ViewPopup.vue?vue&type=template&id=19596113&"
import script from "./ViewPopup.vue?vue&type=script&lang=ts&"
export * from "./ViewPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports